export const reportPage = {
  path: '/report',
  name: 'report',
  component: () => import('./views/report.vue'),
  meta: {
    title: 'Сообщение о проблеме',
    layout: 'redesign',
  },
};

const routes = [reportPage];

export default routes;
